import type { FC } from 'react';
import styled from 'styled-components';
import { Icon, IconType } from '../../../Props/Icon/Icon';

export const HeaderCellWithSort: FC<{
  name: string | React.ReactNode;
  sortActive: boolean;
  sortDirection?: number;
  onSortChange?: () => void;
}> = ({ name, sortActive, sortDirection, onSortChange }) => {
  return (
    <Container onClick={onSortChange} sortActive={sortActive}>
      <Span>{name}</Span>
      <DownArrowIcon
        icon={IconType.SORT}
        width={14}
        height={14}
        fill="transparent"
        $up={sortActive ? !sortDirection : false}
        $sortActive={sortActive}
      />
    </Container>
  );
};

const Span = styled.span`
  color: ${(props) => props.theme.colors.normal};
  transition: opacity 250ms;
`;

const DownArrowIcon = styled(Icon)<{
  $up?: boolean;
  $sortActive: boolean;
}>`
  flex: none;
  transform: rotate(${(props) => (props.$up ? -180 : 0)}deg) translateY(${(props) => (props.$up ? 0 : -1)}px);
  transform-origin: center;
  transition:
    transform 450ms cubic-bezier(0.175, 0.885, 0.32, 1.275),
    opacity 250ms,
    visibility 250ms;
  opacity: ${(props) => (props.$sortActive ? 1 : 0.3)};
`;

const Container = styled.div<{ sortActive: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  gap: 5px;
`;
